module.exports = __webpack_public_path__ + "static/media/roofExhaust.ff174a34.png";